const AnalyticCard = ({backColor = '#FFEEEE', color = '#FF635A', data}) => {
    return(
        <li className={'analytics-card flex border-radius-8 gap-20'} style={{backgroundColor: backColor, color: color}}>
            <div className="number sf-bold">{data?.number}<span className={'font-30'}>{data?.suf}</span></div>
            <div className="title sf-medium">{data?.title}</div>
        </li>
    )
}

export default AnalyticCard;
